import { render, staticRenderFns } from "./ListSchoolSupplies.vue?vue&type=template&id=27a4e49a"
import script from "./ListSchoolSupplies.vue?vue&type=script&lang=js"
export * from "./ListSchoolSupplies.vue?vue&type=script&lang=js"
import style0 from "./ListSchoolSupplies.vue?vue&type=style&index=0&id=27a4e49a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports